<template>
	<div>
		<el-card>
			<el-form :model="form" ref="form" :inline="true">
				<el-form-item label="订单编号:">
					<el-input placeholder="请输入订单编号" v-model="form.orderid" style="width: 350px;"></el-input>
				</el-form-item>
                <!-- <el-form-item label="用户姓名:">
					<el-input placeholder="请输入用户姓名" v-model="form.name" style="width: 350px;"></el-input>
				</el-form-item> -->
				<el-form-item label="状态:">
					<el-select v-model="form.state" placeholder="请选择状态">
						<el-option label="充值统计" value="0"></el-option>
						<el-option label="支出统计" value="1"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="流水日期:">
                    <el-date-picker
                        v-model="form.time"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                </el-form-item>
				
				<el-form-item>
					<el-button type="primary" @click="submitForm()">查询</el-button>
					<el-button @click="resetForm()">重置</el-button>
				</el-form-item>
			</el-form>
			
		</el-card>

		<WriterMoney  :items="writerMoney" />
		
		<!-- <el-card>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="order_num" label="流水编号" width="180">
				</el-table-column>
				
				<el-table-column prop="enter_name" label="用户实名" >
                    <template slot-scope="scope">
						<div style="cursor: pointer;" @click="gofinduser(scope.row.enter_name)">
							{{scope.row.enter_name}}
						</div>
						
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="用户昵称" >
				</el-table-column>
                <el-table-column prop="payer" label="付款方" >
				</el-table-column>
				<el-table-column prop="payee" label="收款方" >
				</el-table-column>
				<el-table-column prop="price" label="流水金额" >
					<template slot-scope="scope">
						<div style="color: red;" v-if="scope.row.type == 1">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 8">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 4">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 5">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 17">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 15">{{scope.row.price}} -</div>
						<div style="color: green;" v-else-if="scope.row.type == 0">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 2">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 6">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 9">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 11">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 13">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 14">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 16">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 19">{{scope.row.price}} +</div>
						<div v-else >{{scope.row.price}} </div>
					</template>
				</el-table-column>
                <el-table-column prop="tradingSector" label="交易板块" >
				</el-table-column>
				<el-table-column prop="tradingPlatform" label="交易平台" >
				</el-table-column>
		
				<el-table-column prop="start_time" label="交易时间" width="180">
				</el-table-column>
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card> -->
		<el-card>
			<el-table :data="tableData" style="width: 100%">
				<!-- <el-table-column type="index" width="50">
				</el-table-column> -->
				<el-table-column prop="id" label="编号" >
				</el-table-column>
				<el-table-column prop="start_time" label="交易时间" >
				</el-table-column>
				<el-table-column prop="userinfo.nickname" label="用户昵称" >
				</el-table-column>
				<!-- <el-table-column prop="enter_name" label="用户实名" >
                    <template slot-scope="scope">
						<div style="cursor: pointer;" @click="gofinduser(scope.row.enter_name)">
							{{scope.row.enter_name}}
						</div>
					</template>
				</el-table-column> -->
				<el-table-column prop="userinfo.id" label="用户id" >
				</el-table-column>
                <el-table-column prop="userinfo.realName" label="用户实名" >
				</el-table-column>
				<el-table-column prop="userinfo.tel" label="手机号" >
				</el-table-column>
				<el-table-column prop="userinfo.idcard" label="身份证" >
				</el-table-column>
				<!-- <el-table-column prop="price" label="流水金额" >
					<template slot-scope="scope">
						<div style="color: red;" v-if="scope.row.type == 1">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 8">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 4">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 5">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 17">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 15">{{scope.row.price}} -</div>
						<div style="color: green;" v-else-if="scope.row.type == 0">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 2">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 6">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 9">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 11">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 13">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 14">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 16">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 19">{{scope.row.price}} +</div>
						<div v-else >{{scope.row.price}} </div>
					</template>
				</el-table-column> -->
                <el-table-column prop="price" label="交易金额" >
					<template slot-scope="scope">
						<div  >{{scope.row.price}}</div>
						<!-- <div style="color: red;" v-if="scope.row.type == 1">{{scope.row.price}} -</div>
						<div style="color: green;" v-else="scope.row.type == 0">{{scope.row.price}} +</div> -->
					</template>
				</el-table-column>
				<el-table-column prop="endwithdrawal" label="余额" >
				</el-table-column>
				<!-- <el-table-column prop="remark" label="流水备注" width="180">
				</el-table-column>
				<el-table-column  label="流水状态" width="180">
					<template slot-scope="scope">
						<div v-if="scope.row.state == 1">
							已完成
						</div>
						<div v-else>
							进行中
						</div>
					</template>
				</el-table-column> -->
				<el-table-column prop="pay_kind" label="充值平台" >
				</el-table-column>
				<el-table-column prop="order_num" label="流水编号">
				</el-table-column>
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card>
		
	</div>
</template>

<script>
	import Pageing from '../../components/page/page.vue'
	import WriterMoney from '../../components/board/commentWriter'
	import {
		getrwList,
		getFlowimgWater
	} from '../../api/board.js'
	export default {
		components: {
			Pageing,
			WriterMoney
		},
		data() {
			return {
                pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
				formLabelWidth: '120px',
				
				page:1,
				size:10,
				total:0,
				tableData: [],
				runmoney:0,
				checkAll: false,
				form: {
					orderid: '',
					time: '',
                    name:'',
					state:''
				},
				
				forminfo:{},
				writerMoney:[],
			};
		},
		mounted() {
			const queryParams = this.$route.query;
			
			if(queryParams){
				console.log(`output->queryParams`,queryParams)
				this.form.name =queryParams.name
			}
			console.log(`output->this.form.name`,this.form.name)
			this.getuserlist()
		},
		computed: {
			isincome(e){
				console.log(e);
				return true;
			}
		},
		methods: {
            
			resetForm(){
				this.form.orderid =''
				this.form.time =''
                this.form.name =''
				this.form.state =''
				this.getuserlist()
			},
			getuserlist(){
				getFlowimgWater({
					page:this.page,
					where:this.form,
                    type:"all"
				}).then(res=>{
					this.tableData = res.data
					this.total = res.total 
					this.writerMoney = res.writerMoney 
				})

				
			},
			
			submitForm() {
				this.page = 1
				this.getuserlist()
			},
            gofinduser(val){
                this.form.name = val
                this.getuserlist()
            },
			handleChangePage(val){
				this.page = val
				this.getuserlist()
			}
			
		}
	};
</script>

<style lang="less" scoped>
	.runmoney{
		display: flex; 
		flex-direction: column;
		align-items: center;
		ul{
			display: flex;
			li{
				text-align: center;
				margin: 0 20px;
			}
		}
	}
	
</style>
